import React from 'react';

import { useCyclesData, useIndicateursData } from '@/hooks/accueil';
import TileChiffresMois from '../tiles/TileChiffresMois';

type TileChiffresMoisContainerPropsType = {
  /** Force un refresh des données */
  forceRefresh?: boolean;
};

/**
 * Conteneur smart pour TileChiffresMois
 * Gère automatiquement la récupération des indicateurs et cycles
 */
const TileChiffresMoisContainer = ({ forceRefresh }: TileChiffresMoisContainerPropsType) => {
  const {
    indicateurs,
    loading: loadingIndicateurs,
    refresh: refreshIndicateurs,
  } = useIndicateursData();
  const { cycles, loading: loadingCycles, refresh: refreshCycles } = useCyclesData();

  // Effet pour forcer le refresh quand demandé par le parent
  React.useEffect(() => {
    if (forceRefresh) {
      refreshIndicateurs();
      refreshCycles();
    }
  }, [forceRefresh, refreshIndicateurs, refreshCycles]);

  return (
    <TileChiffresMois
      indicateurs={indicateurs}
      cycles={cycles}
      loading={loadingIndicateurs || loadingCycles}
    />
  );
};

export default TileChiffresMoisContainer;
